import {deleteClass, deleteInlineStyle, setInlineStyles} from '../../../helpers/domHelper';
import {getTableColumnWidthActiveColumns} from '../../../helpers/dataHelper';

export function makeFeatureResizable(featuresElements, element, elementIndex, previousElement) {
    const resizableHTML = '<div class=\'resizers\'>\n'
        + '                <div class=\'resizer right\'></div>\n'
        + '            </div>';
    element.parentNode.classList.add('VFeatureBlock-wrapper_resized');
    element.insertAdjacentHTML('beforeend', resizableHTML);
    this.featureResize.element = element;
    addMoveListenersForFeature.call(this, featuresElements, element, elementIndex, previousElement);
}

export function makeFeatureUnResizable() {
    this.featureResize.element = null;
    const resizers = document.querySelector('.resizers');
    if (resizers) {
        deleteClass(resizers.parentNode.parentNode, 'VFeatureBlock-wrapper_resized');
        resizers.remove();
    }
}

export function addMoveListenersForFeature(featuresElements, element, elementIndex, previousElement) {
    const currentFeature = this.featuresData[elementIndex];
    const featureSettings = this.featuresSettings[currentFeature.name];
    const featureAdditionalColumns = this.currentBoard.additionalColumnsByFeatureName[currentFeature.name.split(' ')[0].toLowerCase()];
    let additionalColumnsWidth = 0;
    if (featureAdditionalColumns) {
        additionalColumnsWidth = featureAdditionalColumns.reduce((sum, column) => {
            sum += column.width;
            return sum;
        }, 0);
    }
    let mouseOffset;
    let spaceForFeature;
    const featuresBlock = document.querySelector('.VTableBlocks-draggable').getBoundingClientRect();
    const resizers = element.children.item(Array.from(element.children).findIndex((ch) => ch.className === 'resizers')).children;
    const featureRef = this.$refs.vfeatureblock[elementIndex];
    const columnWidth = getTableColumnWidthActiveColumns(featureRef.feature.columnsWidth, this.currentBoard.deletedEventsAndFormulasIndexes.concat(featureRef.feature.deletedIndexes));
    const minNameWidth = 40;

    const offsets = {
        borderRight: 4,
        margins: 20,
        paddings: 30,
    };
    const tableWidthWithoutName = featureSettings ? featureSettings.width - featureSettings.nameWidth : minNameWidth;

    const table = {
        newWidth: 0,
        oldWidth: element.getBoundingClientRect().width,
        minWidth: Math.max((columnWidth + offsets.borderRight + offsets.paddings + minNameWidth + additionalColumnsWidth), 350) + window.scrollX,
        maxWidth: featuresBlock.right - (element.getBoundingClientRect().left - 10) - offsets.margins - offsets.borderRight + window.scrollX,
    };
    const isFeatureOnSameRowWithPrevious = previousElement ? element.getBoundingClientRect().top === previousElement.getBoundingClientRect().top : false;
    const self = this;
    for (let i = 0; i < resizers.length; i++) {
        const currentResizer = resizers[i];
        currentResizer.addEventListener('mousedown', function (e) {
            e.preventDefault();
            self.featureResize.isActive = true;
            window.addEventListener('mousemove', listenerMouseMove);
            window.addEventListener('mouseup', listenerMouseUp);
        });
    }

    function resize(newFeatureWidth) {
        setInlineStyles(element, {
            'width': `${newFeatureWidth - window.scrollX}px`,
        });
    }

    function listenerMouseMove(e) {
        const currentFeaturePositions = element.getBoundingClientRect();
        if (!mouseOffset) {
            mouseOffset = currentFeaturePositions.right - e.pageX;
            if (previousElement && !isFeatureOnSameRowWithPrevious) {
                spaceForFeature = Math.floor(featuresBlock.right - previousElement.getBoundingClientRect().right - offsets.borderRight - 30);
                setInlineStyles(previousElement, {
                    'marginRight': `${spaceForFeature - 10}px`,
                });
            }
        }

        const tempWidth = e.pageX - currentFeaturePositions.left;
        if (tempWidth >= table.maxWidth) {
            table.newWidth = table.maxWidth;
            if (isFeatureOnSameRowWithPrevious) {
                element.classList.add('VFeatureBlock_resized');
            }
        } else if (tempWidth <= table.minWidth) {
            table.newWidth = table.minWidth;
        } else {
            table.newWidth = tempWidth;
            if (!isFeatureOnSameRowWithPrevious && table.newWidth <= spaceForFeature) {
                element.classList.add('VFeatureBlock_resized');
            } else {
                element.classList.remove('VFeatureBlock_resized');
            }
        }
        resize(table.newWidth);
    }

    function listenerMouseUp() {
        if (table.newWidth) {
            if (previousElement) {
                deleteInlineStyle(previousElement, 'margin-right');
            }
            element.classList.remove('VFeatureBlock_resized');
            if (table.newWidth >= table.maxWidth && isFeatureOnSameRowWithPrevious) {
                table.newWidth = table.maxWidth + 1;
                resize(table.newWidth);
            }
            self.featureResize.isActive = false;
            const nameElement = element.querySelector('.VFeatureBlock-headers__name');
            const nameWidth = nameElement ? nameElement.getBoundingClientRect().width : table.newWidth - tableWidthWithoutName;
            const properties = {
                width: table.newWidth,
                nameWidth: nameWidth,
            };
            self.updateFeatureSettingsByProperties(currentFeature.name, properties);
            self.makeFeatureUnResizable();
        }
        window.removeEventListener('mouseup', listenerMouseUp);
        window.removeEventListener('mousemove', listenerMouseMove);
    }
}
